import { h } from 'vue';
import JsBarcode from 'jsbarcode';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Barcode',
  props: {
    value: {
      type: String,
      default: undefined,
    },
    options: {
      type: Object,
      default: undefined,
    },
    tag: {
      type: String,
      default: 'svg',
    },
  },
  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler() {
        if (this.$el) {
          this.generate();
        }
      },
    },
  },
  mounted() {
    this.generate();
  },
  methods: {
    generate() {
      JsBarcode(this.$el, String(this.value), this.options);
    },
  },
  render() {
    return h(this.tag, this.$slots.default);
  },
});
